import { redirect } from '@respond-framework/rudy';
import Resource, { ResourceApi } from '../../resource/Resource';
import { COURSE } from '../resourceNames';

import {
  FETCH_COURSE_ADMIN_DATA_START,
  FETCH_COURSE_ADMIN_DATA_SUCCESS,
  FETCH_COURSE_ADMIN_DATA_FAILURE,
  FETCH_COURSE_LANDING_PAGE_DATA_START,
  FETCH_COURSE_LANDING_PAGE_DATA_SUCCESS,
  FETCH_COURSE_LANDING_PAGE_DATA_FAILURE,
  SAVE_COURSE_LANDING_PAGE_START,
  SAVE_COURSE_LANDING_PAGE_SUCCESS,
  SAVE_COURSE_LANDING_PAGE_FAILURE,
  COPY_COURSE_START,
  COPY_COURSE_SUCCESS,
  COPY_COURSE_FAILURE,
  HIDE_COPY_COURSE_SUCCESS_MODAL,
  HIDE_COPY_COURSE_ERROR_MODAL,
  ADD_COURSE_LANDING_PAGE_TEAM_MEMBER,
  UPDATE_COURSE_LANDING_PAGE_MEDIA,
  REMOVE_COURSE_LANDING_PAGE_TEAM_MEMBER,
  UPDATE_COURSE_LANDING_PAGE_BLURB,
  UPDATE_COURSE_LANDING_PAGE_OUTCOMES_SUMMARY,
  UPDATE_COURSE_LANDING_PAGE_INTRODUCTION,
  UPDATE_COURSE_LANDING_PAGE_FURTHER_INFORMATION,
  UPDATE_COURSE_LANDING_PAGE_CPD_HOURS,
  TOGGLE_COURSE_LANDING_PAGE_HIDE_COST,
  UPDATE_COURSE_LANDING_DEFAULT_COHORT,
  FETCH_CERTIFICATION_SETUP_DATA_START,
  FETCH_CERTIFICATION_SETUP_DATA_SUCCESS,
  FETCH_CERTIFICATION_SETUP_DATA_FAILURE,
  UPDATE_CERTIFICATION_TYPE,
  UPDATE_CERTIFICATION_CODE,
  UPDATE_CERTIFICATION_DATA,
  SAVE_CERTIFICATION_START,
  SAVE_CERTIFICATION_SUCCESS,
  SAVE_CERTIFICATION_FAILURE,
  FETCH_ACCREDIBLE_DESIGNS_START,
  FETCH_ACCREDIBLE_DESIGNS_SUCCESS,
  FETCH_ACCREDIBLE_DESIGNS_FAILURE,
} from './actions';
import { executeAfterMinDelay } from '../../web/utilities/utilities';
import {
  selectCurrentCoursePath,
  currentCourseSelector,
} from '../Courses/selectors';
import {
  selectCopiedCoursePath,
  selectCurrentCourseLandingPageData,
  selectCertificationData,
} from './selectors';
import { ROUTE_COURSE_ADMIN } from '../routeActions';
import { validateCertificationData } from './helpers';
import { sendUserpilotTracking } from '../Userpilot/dispatchers';

export const fetchCourseAdminData = (coursePath) => {
  return (dispatch) => {
    dispatch({ type: FETCH_COURSE_ADMIN_DATA_START });
    return Resource.read('course', coursePath, 'canAccessEmails').then(
      (canAccessEmails) => {
        dispatch({
          type: FETCH_COURSE_ADMIN_DATA_SUCCESS,
          coursePath,
          canAccessEmails,
        });
      },
      (error) => {
        dispatch({ type: FETCH_COURSE_ADMIN_DATA_FAILURE, error });
      }
    );
  };
};

export const fetchCourseLandingPageData = (coursePath) => {
  return (dispatch) => {
    dispatch({ type: FETCH_COURSE_LANDING_PAGE_DATA_START });
    const startTime = Date.now();
    return Resource.read(
      'course',
      coursePath,
      'getPortalCourseLandingPageSetupData'
    ).then(
      (landingPageData) => {
        executeAfterMinDelay(
          () => {
            dispatch({
              type: FETCH_COURSE_LANDING_PAGE_DATA_SUCCESS,
              landingPageData,
              coursePath,
            });
          },
          startTime,
          300
        );
      },
      (error) => {
        dispatch({ type: FETCH_COURSE_LANDING_PAGE_DATA_FAILURE, error });
      }
    );
  };
};

export const addLandingPageTeamMember = (teamMember) => {
  return (dispatch, getState) => {
    dispatch({
      type: ADD_COURSE_LANDING_PAGE_TEAM_MEMBER,
      coursePath: selectCurrentCoursePath(getState()),
      teamMember,
    });
  };
};

export const removeLandingPageTeamMember = (profileName) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const state = getState();
      const coursePath = selectCurrentCoursePath(state);
      const landingPageData = selectCurrentCourseLandingPageData(state);
      const teamMembers = landingPageData
        .get('teamMembers')
        .filter((tm) => tm !== profileName);
      if (teamMembers.size) {
        dispatch({
          type: REMOVE_COURSE_LANDING_PAGE_TEAM_MEMBER,
          coursePath,
          profileName,
        });
        resolve();
      } else {
        reject(new Error('Must have at least one team member'));
      }
    });
  };
};

export const updateLandingPageMedia = ({
  promoImageUrl,
  promoVideoUrl,
  mediaType,
}) => {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_COURSE_LANDING_PAGE_MEDIA,
      coursePath: selectCurrentCoursePath(getState()),
      promoImageUrl,
      promoVideoUrl,
      mediaType,
    });
  };
};

export const updateLandingPageBlurb = (blurb) => {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_COURSE_LANDING_PAGE_BLURB,
      coursePath: selectCurrentCoursePath(getState()),
      blurb,
    });
  };
};

export const updateLandingPageOutcomesSummary = (summary) => {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_COURSE_LANDING_PAGE_OUTCOMES_SUMMARY,
      coursePath: selectCurrentCoursePath(getState()),
      summary,
    });
  };
};

export const updateLandingPageIntroduction = (introduction) => {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_COURSE_LANDING_PAGE_INTRODUCTION,
      coursePath: selectCurrentCoursePath(getState()),
      introduction,
    });
  };
};

export const updateLandingPageFurtherInformation = (furtherInformation) => {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_COURSE_LANDING_PAGE_FURTHER_INFORMATION,
      coursePath: selectCurrentCoursePath(getState()),
      furtherInformation,
    });
  };
};

export const updateLandingPageCpdHours = (CpdHours) => {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_COURSE_LANDING_PAGE_CPD_HOURS,
      coursePath: selectCurrentCoursePath(getState()),
      CpdHours,
    });
  };
};

export const toggleLandingPageHideCost = () => {
  return (dispatch, getState) => {
    dispatch({
      type: TOGGLE_COURSE_LANDING_PAGE_HIDE_COST,
      coursePath: selectCurrentCoursePath(getState()),
    });
  };
};

export const updateLandingPageDefaultCohort = (defaultCohortPath) => {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_COURSE_LANDING_DEFAULT_COHORT,
      coursePath: selectCurrentCoursePath(getState()),
      defaultCohortPath,
    });
  };
};

export const saveLandingPageData = () => {
  return (dispatch, getState) => {
    const state = getState();
    const coursePath = selectCurrentCoursePath(state);
    const updatedData = selectCurrentCourseLandingPageData(state).toJS();

    dispatch({
      type: SAVE_COURSE_LANDING_PAGE_START,
      coursePath,
      data: updatedData,
    });

    const { promoImageUrl, promoVideoUrl, mediaType, ...data } = updatedData;

    return ResourceApi.update('course', coursePath, [
      {
        method: 'setLandingPageMedia',
        args: {
          promoImageUrl,
          promoVideoUrl,
          mediaType,
        },
      },
      { method: 'updateCourseLandingPage', args: { data } },
    ]).then(
      (results) => {
        const landingPageData = results[1];
        dispatch({
          type: SAVE_COURSE_LANDING_PAGE_SUCCESS,
          coursePath,
          landingPageData,
        });

        if (promoImageUrl) {
          dispatch(sendUserpilotTracking('PromoImage-Saved'));
        }

        if (promoVideoUrl) {
          dispatch(sendUserpilotTracking('PromoVideo-Saved'));
        }
        return landingPageData;
      },
      (error) => {
        dispatch({
          type: SAVE_COURSE_LANDING_PAGE_FAILURE,
          coursePath,
        });
        throw error;
      }
    );
  };
};

export const copyCourse = (newCourseCreationData) => {
  return (dispatch, getState) => {
    const state = getState();
    const coursePath = selectCurrentCoursePath(state);

    dispatch({
      type: COPY_COURSE_START,
      coursePath,
      newCourseCreationData,
    });

    return ResourceApi.update(COURSE, coursePath, 'copyTo', {
      creationData: newCourseCreationData,
    }).then(
      () => {
        dispatch({
          type: COPY_COURSE_SUCCESS,
          coursePath,
        });
      },
      (error) => {
        dispatch({
          type: COPY_COURSE_FAILURE,
          coursePath,
          error: error.message,
        });
        throw error;
      }
    );
  };
};

export const dismissCourseCopySuccessModal = () => {
  return (dispatch, getState) => {
    const state = getState();
    const coursePath = selectCurrentCoursePath(state);

    dispatch({
      type: HIDE_COPY_COURSE_SUCCESS_MODAL,
      coursePath,
    });
  };
};

export const dismissCourseCopyErrorModal = () => {
  return (dispatch, getState) => {
    const state = getState();
    const coursePath = selectCurrentCoursePath(state);

    dispatch({
      type: HIDE_COPY_COURSE_ERROR_MODAL,
      coursePath,
    });
  };
};

export const goToCopiedCourse = () => {
  return (dispatch, getState) => {
    const state = getState();
    const coursePath = selectCopiedCoursePath(state);
    dispatch(
      redirect({ type: ROUTE_COURSE_ADMIN, query: { course: coursePath } })
    );
  };
};

export function fetchCertificationSetupData() {
  return (dispatch, getState) => {
    const state = getState();
    const coursePath = selectCurrentCoursePath(state);

    dispatch({
      type: FETCH_CERTIFICATION_SETUP_DATA_START,
      coursePath,
    });

    return ResourceApi.read(
      COURSE,
      coursePath,
      'getCertificationSetupData'
    ).then(
      (results) => {
        dispatch({
          type: FETCH_CERTIFICATION_SETUP_DATA_SUCCESS,
          coursePath,
          ...results,
        });
      },
      (err) => {
        dispatch({
          type: FETCH_CERTIFICATION_SETUP_DATA_FAILURE,
          error: err.message,
        });
        throw err;
      }
    );
  };
}

export const updateCertificationType = (certificationType) => {
  return (dispatch, getState) => {
    const state = getState();
    const coursePath = selectCurrentCoursePath(state);
    const course = currentCourseSelector(state);

    dispatch({
      type: UPDATE_CERTIFICATION_TYPE,
      coursePath,
      certificationType,
      courseUrl: course.get('url', ''),
      courseName: course.get('name', ''),
    });
  };
};

export const updateCertificationCode = (code) => {
  return (dispatch, getState) => {
    const state = getState();
    const coursePath = selectCurrentCoursePath(state);

    dispatch({
      type: UPDATE_CERTIFICATION_CODE,
      coursePath,
      code,
    });
  };
};

export const updateCertificationData = (changes) => {
  return (dispatch, getState) => {
    const state = getState();
    const coursePath = selectCurrentCoursePath(state);

    dispatch({
      type: UPDATE_CERTIFICATION_DATA,
      coursePath,
      changes,
    });
  };
};

export const saveCertification = () => {
  return (dispatch, getState) => {
    const state = getState();
    const coursePath = selectCurrentCoursePath(state);

    dispatch({
      type: SAVE_CERTIFICATION_START,
      coursePath,
    });

    const certificationData = selectCertificationData(getState());
    const errors = validateCertificationData(certificationData);

    if (errors.size) {
      dispatch({
        type: SAVE_CERTIFICATION_FAILURE,
        coursePath,
        errors: errors.toJS(),
      });
      return Promise.resolve();
    }

    const startTime = Date.now();
    return ResourceApi.update(COURSE, coursePath, 'updateCertification', {
      certType: certificationData.get('type'),
      code: certificationData.get('code'),
      data: certificationData.get('data').toJS(),
    }).then(
      (result) => {
        executeAfterMinDelay(
          () => {
            dispatch({
              type: SAVE_CERTIFICATION_SUCCESS,
              certificationData: result,
              coursePath,
            });
          },
          startTime,
          300
        );
      },
      (err) => {
        dispatch({
          type: SAVE_CERTIFICATION_FAILURE,
          coursePath,
          errors: {
            _error: err.response.reason,
          },
        });
      }
    );
  };
};

export function fetchAccredibleDesigns() {
  return (dispatch, getState) => {
    const state = getState();
    const coursePath = selectCurrentCoursePath(state);

    // start
    dispatch({
      type: FETCH_ACCREDIBLE_DESIGNS_START,
      coursePath,
    });

    return ResourceApi.read(COURSE, coursePath, 'showAccredibleDesigns').then(
      (results) => {
        dispatch({
          type: FETCH_ACCREDIBLE_DESIGNS_SUCCESS,
          coursePath,
          accredibleDesigns: {
            badges:
              results.badge?.map((badge) => ({
                url: badge.rasterized_content_url,
                name: badge.design_name,
                id: badge.design_id,
              })) ?? [],
            certificates:
              results.certificate?.map((certificate) => ({
                url: certificate.rasterized_content_url,
                name: certificate.design_name,
                id: certificate.design_id,
              })) ?? [],
          },
        });
      },
      (err) => {
        dispatch({
          type: FETCH_ACCREDIBLE_DESIGNS_FAILURE,
          error: err.message,
        });
        throw err;
      }
    );
  };
}
